import React, { useCallback, useEffect, useRef, useState } from "react";
import { useRecoilValue, useSetRecoilState } from "recoil";
import { rowSelected, userCredentials } from "recoilState/GlobalState";
import { SBMDocumentoPreviewGet } from "services/services-mia/sbm/SBMDocumentoPreviewGet";
import PdfViewerComponent from "./PdfViewerComponent";
import styles from "./ViewDoc.module.scss";
import { snackbarData } from "recoilState/GlobalState";

const base64ToBlobUrl = (base64) => {
    const byteCharacters = atob(base64);
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);
    const blob = new Blob([byteArray], { type: "application/pdf" });
    return URL.createObjectURL(blob);
};

export default function ViewDoc({ updateList }) {
    const credentials = useRecoilValue(userCredentials);
    const xgridRowSelected = useRecoilValue(rowSelected);
    const setSnackbarInfo = useSetRecoilState(snackbarData);
    const [pdf, setPdf] = useState({ status: false, content: "" });
    const blobUrlRef = useRef(null);

    const getDoc = useCallback(async () => {
        const response = await SBMDocumentoPreviewGet(xgridRowSelected.row.id, credentials);
        if (response.result.length === 0 || !response.result[0].sbmDocumentoPDF) {
            setSnackbarInfo({
                isOpen: true,
                message: "No se encontró el documento",
                severity: "error"
            });
            return;
        }
        if (blobUrlRef.current) URL.revokeObjectURL(blobUrlRef.current);
        const blobUrl = base64ToBlobUrl(response.result[0].sbmDocumentoPDF);
        blobUrlRef.current = blobUrl;
        setPdf({ status: true, content: blobUrl });
    }, [credentials, xgridRowSelected?.row?.id, setSnackbarInfo]);

    useEffect(() => {
        getDoc();
        return () => {
            if (blobUrlRef.current) URL.revokeObjectURL(blobUrlRef.current);
        };
    }, [getDoc]);

    const handleDownloadPdf = async (e) => {
        e.preventDefault();
        const responseDownload = await SBMDocumentoPreviewGet(xgridRowSelected.row.id, credentials);
        if (!responseDownload.result[0]?.sbmDocumentoPDF) return;
        const urlBlob = base64ToBlobUrl(responseDownload.result[0].sbmDocumentoPDF);
        const a = document.createElement("a");
        a.href = urlBlob;
        a.download = `${xgridRowSelected.row["Nombre"]}.pdf`;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        URL.revokeObjectURL(urlBlob);
    };
    console.log('pdf: ', pdf)
    return (
        <>
            <section>
                {pdf.status && <PdfViewerComponent pdfContent={pdf.content} />}
            </section>
            <button className={styles.btn} onClick={handleDownloadPdf}>descargar</button>
        </>
    );
}